import {InformationQueueLinks} from './InformationReview';
import { useEffect,useId,useRef,useState } from 'react';
import { Link } from '../ui/ScopedLink';
import { api } from '../api';

import { State } from '../ui/State';
import { validatedPendingSummary,type PendingDocumentSummary } from '../pending-document-summary';
export type {PendingDocumentSummary} from '../pending-document-summary';
type Result={scope:string;attempt:number;summary?:PendingDocumentSummary;failed?:boolean};

export function PendingDocumentsCard({developmentId,compact=false}:{developmentId?:string;compact?:boolean}){
  const [result,setResult]=useState<Result>();
  const [attempt,setAttempt]=useState(0);
  const root=useRef<HTMLDivElement>(null);
  const headingId=useId();
  const scope=developmentId??'';
  useEffect(()=>{
    let active=true;const controller=new AbortController();
    const query=scope?`?building=${encodeURIComponent(scope)}`:'';
    void api<unknown>(`/api/documents/pending-summary${query}`,{signal:controller.signal,cache:'no-store'})
      .then(value=>validatedPendingSummary(value,scope||undefined))
      .then(summary=>{if(active)setResult({scope,attempt,summary});})
      .catch(()=>{if(active)setResult({scope,attempt,failed:true});});
    return ()=>{active=false;controller.abort();};
  },[scope,attempt]);
  const current=result?.scope===scope&&result.attempt===attempt?result:undefined;
  const summary=current?.summary;
  if(summary?.totalPending===0&&attempt===0)return null;
  const query=new URLSearchParams({status:'all'});if(scope)query.set('building',scope);
  return <div ref={root} role="group" tabIndex={-1} aria-label="Pending document attention">
    {!current?<State kind="loading" tone="neutral" headingLevel={2} heading="Checking documents awaiting filing" message="Pending review counts are loading for the current scope."/>:
      current.failed?<State kind="partial" tone="warning" headingLevel={2} heading="Document attention unavailable" message="Pending review counts could not be confirmed. Other records remain available." retry={{label:'Retry document attention',onRetry:()=>{root.current?.focus();setAttempt(value=>value+1);}}}/>:
      summary&&summary.totalPending>0?<section className={`pending-documents-card${compact?' compact':''}`} aria-labelledby={headingId}>
        <div><span className="eyebrow">Pending review</span><h2 id={headingId}>{summary.totalPending} uploaded {summary.totalPending===1?'document is':'documents are'} awaiting filing</h2><p>{summary.readyForReview} ready for review · {summary.needsAttention} need attention · {summary.processing} processing{!scope&&summary.unlinked?` · ${summary.unlinked} not yet linked to a building`:''}
          {summary.filedWithDetails?` · ${summary.filedWithDetails} already filed, details to confirm`:''}</p></div>
        <Link className="button-link" to={`/documents/review?${query}`}>Open general triage</Link>{compact?<details><summary>Specialist review queues</summary><InformationQueueLinks/></details>:<InformationQueueLinks/>}
      </section>:attempt>0?<State kind="empty" tone="neutral" headingLevel={2} heading="No documents awaiting filing" message="No pending documents were found in the current scope."/>:null}
  </div>;
}
